$('body').on('change', '.rating input', function() {
    let radio = $(this);
    $('.rating .selected').removeClass('selected').prop('checked', false);
    radio.closest('label').addClass('selected');
    radio.prop('checked', true);
})
